import React, { useState} from "react";

const initialState = {
    name: "peter",
    email: "peter@peter.de",
    language: "en",
};

export const Context = React.createContext();

const Store = ({ children }) => {
    // const [state, setState] = useState(initialState);
    const [state, setState] = useState(initialState);

    return (
        <Context.Provider value={[state, setState]}>
            {children}
        </Context.Provider>
    );
};
export default Store;
